import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  const inputCls =
    "w-full bg-transparent border-b border-white/20 py-3 text-lg placeholder:text-neutral-600 focus:border-[var(--yellow)] focus:outline-none transition-colors";

  return (
    <main className="bg-[#0A0A0A] min-h-screen flex items-center justify-center px-5">
      <div className="w-full max-w-sm">
        <Link to="/" className="font-display text-3xl tracking-tight leading-none block mb-2">
          DISTÓPICA<span style={{ color: "var(--fuchsia)" }}>.</span>
        </Link>
        <p className="font-mono-x text-xs uppercase tracking-[0.2em] text-neutral-500 mb-10 flex items-center gap-2">
          <Lock size={14} /> Panel de administración
        </p>

        <form onSubmit={submit} className="flex flex-col gap-7" data-testid="admin-login-form">
          <input data-testid="login-email" className={inputCls} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" className={inputCls} type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} />
          {error && <p className="text-[var(--fuchsia)] text-sm font-mono-x" data-testid="login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="bg-[var(--yellow)] text-black font-mono-x uppercase text-sm tracking-[0.15em] px-7 py-4 rounded-sm hover:bg-white transition-colors disabled:opacity-60"
          >
            {loading ? "Ingresando…" : "Ingresar"}
          </button>
        </form>
      </div>
    </main>
  );
}
